import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/internal/Observable";
import {ProjectCostDataSummary, QBChargeCodeMapping, QBUserMapping, TimeSheetImportCell, TimesheetImportCellInfo} from "@app/shared/classes/quickbooks/qbuser-mapping";
import {ChargeCode} from "@app/shared";

@Injectable({
  providedIn: 'root'
})
export class QuickBooksImportDataService {

  constructor(private http: HttpClient) { }

  getImportCells(): Observable<TimeSheetImportCell[]> {
    const url = '/quickbooks-import/import-cells';
    return this.http.get<TimeSheetImportCell[]>(url);
  }

  validateImportCells(): Observable<TimesheetImportCellInfo[]> {
    const url = '/quickbooks-import/time-sheets-import/validate';
    return this.http.get<TimesheetImportCellInfo[]>(url);
  }
  fixValidationForImportCells(): Observable<TimesheetImportCellInfo[]> {
    const url = '/quickbooks-import/time-sheets-import/validate-update';
    return this.http.get<TimesheetImportCellInfo[]>(url);
  }

  saveImportCells(mappings: TimeSheetImportCell[]): Observable<TimeSheetImportCell[]> {
    const url = '/quickbooks-import/import-cells';
    return this.http.put<TimeSheetImportCell[]>(url, mappings);
  }

  getUserMappings():Observable<QBUserMapping[]>{
    const url = '/quickbooks-import/user-mappings';
    return this.http.get<QBUserMapping[]>(url);
  }
  importUserMappings():Observable<QBUserMapping[]>{
    const url = '/quickbooks-import/user-mappings-import';
    return this.http.post<QBUserMapping[]>(url, {});
  }

  saveUserMappings(mappings: QBUserMapping[]): Observable<QBUserMapping[]> {
    const url = '/quickbooks-import/user-mappings';
    return this.http.put<QBUserMapping[]>(url, mappings);
  }

  getChargeCodeMappings():Observable<QBChargeCodeMapping[]>{
    const url = '/quickbooks-import/charge-codes';
    return this.http.get<QBChargeCodeMapping[]>(url);
  }

  importChargeCodes(): Observable<QBChargeCodeMapping[]>{
    let url = '/quickbooks-import/charge-codes-import';
    return this.http.post<QBChargeCodeMapping[]>(url, {});
  }

  importTimesheets(timesheetPeriodId: number, userId?: number):Observable<QBChargeCodeMapping[]>{
    let url = '/quickbooks-import/time-sheets-import';
    if(timesheetPeriodId){
      url += `?timeSheetPeriodId=${timesheetPeriodId}`;
    }
    if(userId){
      url += `&userId=${userId}`;
    }
    return this.http.get<QBChargeCodeMapping[]>(url);
  }

  importPartialTimeSheets(timesheetPeriodId: number, userId: number, startDate: string, endDate: string, appendLines: boolean):Observable<QBChargeCodeMapping[]>{
    let url = '/quickbooks-import/time-sheets-import/partial';
    if(timesheetPeriodId){
      url += `?timeSheetPeriodId=${timesheetPeriodId}`;
    }
    if(userId){
      url += `&userId=${userId}`;
    }
    if(startDate){
      url += `&startDate=${startDate}`;
    }
    if(endDate){
      url += `&endDate=${endDate}`;
    }
    if(appendLines){
      url += `&appendLines=${appendLines}`;
    }
    return this.http.get<QBChargeCodeMapping[]>(url);
  }

  saveChargeCodeMappings(mappings: QBChargeCodeMapping[]): Observable<QBChargeCodeMapping[]> {
    const url = '/quickbooks-import/charge-codes';
    return this.http.put<QBChargeCodeMapping[]>(url, mappings);
  }

  getChargeableChargeCodes(): Observable<ChargeCode[]> {
    const url = '/finance/chargeable-charge-codes';
    return this.http.get<ChargeCode[]>(url);
  }

  importProjectCostData(projectCostDataSummary: ProjectCostDataSummary): Observable<any> {
    const  url = `/data-import/setup-project`;
    return this.http.post<any[]>(url, projectCostDataSummary);
  }


}
